/**
 * Updates a url parameter with a new value
 * Replaces the current URL in the browser history
 *
 * @param key - The key of the URL parameter to replace
 * @param value - The value to replace the URL parameter with
 */
export const replaceUrlParam = (key: string, value: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState({}, '', url.toString());
};

/**
 * Updates the URL by adding or updating a query parameter.
 * Pushes the new URL to the browser history.
 *
 * @param k - The key of the URL parameter to push
 * @param v - The value of the URL parameter to push
 */
export function pushUrlParam(k: string, v: string): void {
  const url = new URL(window.location.href);
  url.searchParams.set(k, v);
  history.pushState({}, '', url.toString());
}
